module.exports = __webpack_public_path__ + "img/figure-9.a5360607.png";